import React from "react";
import { Award } from "lucide-react";
import { ACCREDITATIONS } from "../data/content";
import { PAGE_SEO } from "../data/seoContent";
import SEO, { breadcrumbSchema } from "../components/SEO";
import Breadcrumb from "../components/Breadcrumb";

export default function Accreditations() {
  const crumbs = [{ name: "Home", path: "/" }, { name: "Accreditations", path: "/accreditations" }];
  return (
    <div data-testid="page-accreditations">
      <SEO {...PAGE_SEO.accreditations} schema={breadcrumbSchema(crumbs)} />
      <section className="bg-[#0A0F1C] text-white pt-16 pb-24 lg:pt-24 lg:pb-32">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="mb-8"><Breadcrumb items={crumbs} theme="dark" /></div>
          <p className="text-[10px] uppercase tracking-[0.3em] text-white/50 mb-6">Accreditations &amp; Certifications</p>
          <h1 className="font-display text-5xl lg:text-7xl font-bold tracking-tight max-w-4xl leading-[1.05]">
            Accredited. Audited. <span className="gs-gradient-text">Assured.</span>
          </h1>
          <p className="mt-8 text-lg text-white/70 max-w-2xl leading-relaxed">
            Independent verification of our management systems, technical competence and supply-chain compliance.
          </p>
        </div>
      </section>

      <section className="bg-white py-20">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200 border border-slate-200">
            {ACCREDITATIONS.map((a, i) => (
              <div key={i} className="bg-white p-10 min-h-[220px] flex flex-col justify-between" data-testid={`acc-${i}`}>
                <Award className="w-8 h-8 text-[#3FBAB0]" strokeWidth={1.5} />
                <div>
                  <p className="font-display text-2xl font-bold text-slate-900 mt-8">{a.name}</p>
                  {a.full && <p className="text-sm text-slate-600 mt-1" data-testid={`acc-${i}-full`}>{a.full}</p>}
                  <p className="text-sm text-slate-500 mt-2 uppercase tracking-wider">{a.sub}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
